/**
 * Hashtag — clickable hashtag that filters the feed by the selected tag.
 * Renders as a button for keyboard accessibility. Navigation and filtering
 * live in `useHashtagNavigate`, shared with the rich-text renderer.
 */
import { type MouseEvent } from 'react';
import { useHashtagNavigate } from './richTextNavigation';
import './richText.css';

interface HashtagProps {
  /** The full hashtag text including the # prefix, e.g. "#Progress". */
  children: string;
}

export function Hashtag({ children }: HashtagProps) {
  const navigateToHashtag = useHashtagNavigate();

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    navigateToHashtag(children);
  };

  return (
    <button type="button" className="hashtag-link" onClick={handleClick}>
      {children}
    </button>
  );
}
